import { render, staticRenderFns } from "./UpdatesOrdered.vue?vue&type=template&id=b20b9d3a&scoped=true&"
import script from "./UpdatesOrdered.vue?vue&type=script&lang=js&"
export * from "./UpdatesOrdered.vue?vue&type=script&lang=js&"
import style0 from "./UpdatesOrdered.vue?vue&type=style&index=0&id=b20b9d3a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b20b9d3a",
  null
  
)

export default component.exports